(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper')
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-template"]) return;
  try {
    
  /* Smart Supply stable collection filter fix - no hidden In Stock filter.
     Goal:
     - Do not force filter.v.availability=1.
     - Let Shopify collection rules control which products belong in the collection.
     - Force filter checkbox, sort, clear all, and active filter chips to use normal page reload.
     - Rebuild URL only from currently selected filters, so clicking a selected checkbox again removes it.
  */
  (function() {
    var SS_RELOAD_TIMER = null;

    function SS_keepCurrentSort(url) {
      var sortSel = document.querySelector('#SortBy-sidebar, #SortBy');
      if (sortSel && sortSel.value) {
        url.searchParams.set('sort_by', sortSel.value);
      } else {
        var current = new URL(window.location.href);
        if (current.searchParams.has('sort_by')) {
          url.searchParams.set('sort_by', current.searchParams.get('sort_by'));
        }
      }
    }

    function SS_removeAllFilterParams(url) {
      Array.from(url.searchParams.keys()).forEach(function(key) {
        if (key.indexOf('filter.') === 0 || key === 'page') {
          url.searchParams.delete(key);
        }
      });
    }

    function SS_collectSelectedFilters(url) {
      var scope = document.querySelector('#main-collection-filters') || document;
      var fields = scope.querySelectorAll('input[name^="filter."], select[name^="filter."]');

      fields.forEach(function(field) {
        if (!field || field.disabled) return;

        var name = field.getAttribute('name');
        if (!name) return;

        var type = (field.getAttribute('type') || '').toLowerCase();
        var value = field.value;

        if (type === 'checkbox' || type === 'radio') {
          if (field.checked && value !== '') {
            url.searchParams.append(name, value);
          }
          return;
        }

        if (value !== null && String(value).trim() !== '') {
          url.searchParams.append(name, String(value).trim());
        }
      });
    }

    function SS_buildCollectionUrlFromSelectedFilters() {
      var url = new URL(window.location.href);
      SS_removeAllFilterParams(url);
      SS_collectSelectedFilters(url);
      SS_keepCurrentSort(url);
      return url;
    }

    function SS_goToUrl(url) {
      var next = url.toString();
      if (next === window.location.href) {
        window.location.reload();
      } else {
        window.location.href = next;
      }
    }

    function SS_scheduleFilterReload() {
      if (SS_RELOAD_TIMER) window.clearTimeout(SS_RELOAD_TIMER);
      SS_RELOAD_TIMER = window.setTimeout(function() {
        SS_goToUrl(SS_buildCollectionUrlFromSelectedFilters());
      }, 80);
    }

    function SS_findFilterInputFromEventTarget(target) {
      if (!target) return null;

      var input = target.closest && target.closest('input[name^="filter."]');
      if (input) return input;

      var label = target.closest && target.closest('label');
      if (label) {
        input = label.querySelector('input[name^="filter."]');
        if (input) return input;
        var labelFor = label.getAttribute('for');
        if (labelFor) {
          input = document.getElementById(labelFor);
          if (input && input.name && input.name.indexOf('filter.') === 0) return input;
        }
      }

      return null;
    }

    function SS_isFilterClickTarget(target) {
      var input = SS_findFilterInputFromEventTarget(target);
      if (!input || input.disabled) return false;
      return true;
    }

    function SS_handleActiveFacetLink(event) {
      var link = event.target.closest && event.target.closest('a');
      if (!link) return false;

      var className = link.className || '';
      var href = link.getAttribute('href') || '';
      var text = (link.textContent || '').toLowerCase();

      var isFacetLink =
        className.indexOf('active-facets') !== -1 ||
        className.indexOf('facets__reset') !== -1 ||
        href.indexOf('filter.') !== -1 ||
        text.indexOf('clear all') !== -1;

      if (!isFacetLink) return false;

      event.preventDefault();
      event.stopImmediatePropagation();

      var targetUrl;
      if (className.indexOf('facets__reset') !== -1 || text.indexOf('clear all') !== -1) {
        targetUrl = new URL(window.location.pathname, window.location.origin);
        SS_keepCurrentSort(targetUrl);
      } else {
        targetUrl = new URL(link.href, window.location.origin);
        targetUrl.searchParams.delete('page');
      }

      window.location.href = targetUrl.toString();
      return true;
    }

    document.addEventListener('DOMContentLoaded', function() {
      var sortInputs = document.querySelectorAll('#SortBy-sidebar, #SortBy');
      sortInputs.forEach(function(sel) {
        sel.addEventListener('change', function(event) {
          event.preventDefault();
          event.stopImmediatePropagation();
          SS_goToUrl(SS_buildCollectionUrlFromSelectedFilters());
        }, true);
      });

      var scope = document.querySelector('#main-collection-filters') || document;
      scope.querySelectorAll('input[name="filter.v.price.gte"], input[name="filter.v.price.lte"]').forEach(function(input) {
        input.addEventListener('blur', function() {
          SS_goToUrl(SS_buildCollectionUrlFromSelectedFilters());
        }, true);
        input.addEventListener('keydown', function(event) {
          if (event.key === 'Enter') {
            event.preventDefault();
            event.stopImmediatePropagation();
            SS_goToUrl(SS_buildCollectionUrlFromSelectedFilters());
          }
        }, true);
      });
    });

    document.addEventListener('click', function(event) {
      if (SS_handleActiveFacetLink(event)) return;

      if (SS_isFilterClickTarget(event.target)) {
        event.stopImmediatePropagation();
        SS_scheduleFilterReload();
      }
    }, true);

    document.addEventListener('change', function(event) {
      var target = event.target;
      if (target && target.name && target.name.indexOf('filter.') === 0) {
        event.preventDefault();
        event.stopImmediatePropagation();
        SS_scheduleFilterReload();
      }
    }, true);
  })();

  /* Ajaxinate init for click/scroll pagination only. Normal numbered pagination is left unchanged. */
  const getpagi = document.querySelector('.AjaxinatePagination');
  if (typeof(getpagi) !== "undefined" && getpagi !== null) {
    document.addEventListener("DOMContentLoaded", function() {
      const elem = getpagi.getAttribute('data-pagination');
      var endlessScroll = new Ajaxinate({
        container: '.AjaxinateLoop',
        pagination: '.AjaxinatePagination',
        loadingText: '<span class="loader-line"></span>',
        method: elem == 'scroll' ? 'scroll' : 'click'
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
            if (window.SPR && theme.review ) {
              if ($('.shopify-product-reviews-badge').length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
              }
            }
          })
          .catch(e => { console.error(e); });
      };

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 500px 0px'}).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-1"]) return;
  try {
    

var initPhotoSwipeFromDOM = function(gallerySelector) {

// parse slide data (url, title, size ...) from DOM elements 
// (children of gallerySelector)
var parseThumbnailElements = function(el) {
  var thumbElements = Array.prototype.slice.call(document.querySelectorAll('.photo-image')),
    numNodes = thumbElements.length,
    items = [],
    figureEl,
    linkEl,
    size,
    item;

  for (var i = 0; i < numNodes; i++) {

    figureEl = thumbElements[i]; // <figure> element
    // include only element nodes 
    if (figureEl.nodeType !== 1) {
      continue;
    }

    linkEl = figureEl.children[0]; // <a> element
    if(linkEl.getAttribute('data-size')){
      size =  linkEl.getAttribute('data-size').split('x') ;
    }else{
      size =  [] ;
    }
    
    

    // create slide object
    item = {
      src: linkEl.getAttribute('href'),
      w: parseInt(size[0], 10),
      h: parseInt(size[1], 10)
    };



    if (figureEl.children.length > 1) {
      // <figcaption> content
      item.title = figureEl.children[1].innerHTML;
    }

    if (linkEl.children.length > 0) {
      // thumbnail element, retrieving thumbnail url
      item.msrc = linkEl.children[0].getAttribute('src');
    }

    item.el = figureEl; // save link to element for getThumbBoundsFn
    items.push(item);
  }

  return items;
};

// find nearest parent element
var closest = function closest(el, fn) {
  return el && (fn(el) ? el : closest(el.parentNode, fn));
};

// triggers when user clicks on thumbnail
var onThumbnailsClick = function(e) {
  e = e || window.event;
  e.preventDefault ? e.preventDefault() : e.returnValue = false;

  var eTarget = e.target || e.srcElement;

  // find root element of slide
  var clickedListItem = closest(eTarget, function(el) {
    return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
  });

  if (!clickedListItem) {
    return;
  }

  // find index of clicked item by looping through all child nodes
  // alternatively, you may define index via data- attribute
  var clickedGallery = clickedListItem.parentNode,
    childNodes = clickedListItem.parentNode.childNodes,
    numChildNodes = childNodes.length,
    nodeIndex = 0,
    index;

  for (var i = 0; i < numChildNodes; i++) {
    if (childNodes[i].nodeType !== 1) {
      continue;
    }

    if (childNodes[i] === clickedListItem) {
      index = nodeIndex;
      break;
    }
    nodeIndex++;
  }



  if (index >= 0) {
    // open PhotoSwipe if valid index found
    openPhotoSwipe(index, clickedGallery);
  }
  return false;
};

// parse picture index and gallery index from URL (#&pid=1&gid=2)
var photoswipeParseHash = function() {
  var hash = window.location.hash.substring(1),
    params = {};

  if (hash.length < 5) {
    return params;
  }

  var vars = hash.split('&');
  for (var i = 0; i < vars.length; i++) {
    if (!vars[i]) {
      continue;
    }
    var pair = vars[i].split('=');
    if (pair.length < 2) {
      continue;
    }
    params[pair[0]] = pair[1];
  }

  if (params.gid) {
    params.gid = parseInt(params.gid, 10);
  }

  return params;
};

var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
  var pswpElement = document.querySelectorAll('.pswp')[0],
    gallery,
    options,
    items;

  items = parseThumbnailElements(galleryElement);

  // define options (if needed)
  options = {
    maxSpreadZoom: 1, 
    bgOpacity: 0.7,
    zoomEl: true,
    history: false,
    pinchToClose: false,
    closeOnScroll: false,

    // define gallery index (for URL)
    galleryUID: galleryElement.getAttribute('data-pswp-uid'),

  };

  // PhotoSwipe opened from URL
  if (fromURL) {
    if (options.galleryPIDs) {
      // parse real index when custom PIDs are used 
      // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
      for (var j = 0; j < items.length; j++) {
        if (items[j].pid == index) {
          options.index = j;
          break;
        }
      }
    } else {
      // in URL indexes start from 1
      options.index = parseInt(index, 10) - 1;
    }
  } else {
    options.index = parseInt(index, 10);
  }

  // exit if index not found
  if (isNaN(options.index)) {
    return;
  }

  if (disableAnimation) {
    options.showAnimationDuration = 0;
  }

  // Pass data to PhotoSwipe and initialize it
  gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
  gallery.init();
};

// loop through all gallery elements and bind events
var galleryElements = document.querySelectorAll(gallerySelector);

for (var i = 0, l = galleryElements.length; i < l; i++) {
  galleryElements[i].setAttribute('data-pswp-uid', i + 1);
  galleryElements[i].onclick = onThumbnailsClick;
}

// Parse URL and open gallery if it contains #&pid=3&gid=1
var hashData = photoswipeParseHash();
if (hashData.pid && hashData.gid) {
  openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
}
};

// execute above function
initPhotoSwipeFromDOM('.my-gallery');


  } catch(e) { console.error(e); }
})();
})();
